module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Mayans-S1.fe25983.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Mayans-S1.jpg
// module id = onTB
// module chunks = 0